export const sizeClasses = {
  xsmall: "text-label",
  small: "text-paragraph-medium",
  default: "text-paragraph",
  large: "text-heading5",
  largex: "text-heading4",
  large2x: "text-heading3",
  large3x: "text-heading2",
  large4x: "text-heading1",
}

export const sizeClassesWidthHeight = {
  xmall: "w-3 h-3",
  small: "w-[14px] h-[14px]",
  default: "w-[16px] h-[16px]",
  large: "w-5 h-5",
  largex: "w-6 h-6",
  large2x: "w-7 h-7",
  large3x: "w-8 h-8",
  large4x: "w-9 h-9",
}

export type SVGIconProps = {
  size?: keyof typeof sizeClassesWidthHeight
  className?: string
}
